module.exports = __webpack_public_path__ + "img/baohuhn.878d2167.jpg";